import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "../pages/LegalPage";

export const Route = createFileRoute("/terms")({
  component: () => <LegalPage initialTab="terms" />,
});
